import { Address, InsuredBusinessInformation } from '../data/models/coverage-validator-api-models';

// "1234 Main Street, Ste 121" / "San Francisco, CA 94213"
export function formatAddressLines(address: Address | null | undefined): string[] {
  if (!address) return [];
  const street = [address.streetAddress, address.suiteOrUnit].filter(Boolean).join(', ');
  const cityLine = `${address.city ?? ''}, ${address.state ?? ''} ${address.zipCode ?? ''}`.trim();
  return [street, cityLine].filter((line) => line && line !== ',');
}

export function formatMailingLines(business: InsuredBusinessInformation | null | undefined): string[] {
  return business?.mailingAddressSameAsPrimary
    ? ['Same as primary', ...formatAddressLines(business.primaryAddress)]
    : formatAddressLines(business?.mailingAddress);
}
